interface GetVirtualIdResponse {
  code: number;
  data: string | null;
  detailMsg: string;
  error_code: string;
  error_message: string;
  msg: string;
}

/**
 * Query current user's virtual ID for GA reporting.
 * @returns virtual ID string, or null when generation failed (data is '0') or request errored.
 */
export async function getUserId() {
  try {
    const data = (await window.utils?.ont?.get('/v3/users/security/virtualId'))
      ?.data as GetVirtualIdResponse | undefined;
    if (data && data.code === 0 && data.data && data.data !== '0') {
      return data.data;
    }
    // eslint-disable-next-line prettier/prettier
  } catch {;}
  return null;
}
